// 留空会直接请求当前项目的public
export const resourceHost = '/gvi';
// CDN host
export const resourceCDNHost = `/resource/static${resourceHost}`;
export const miotechHost = 'https://www.miotech.com';
